import React, { useState, useEffect } from 'react'
import api from '../components/api'
import ModalProcessaPlanilhaClima from '../modals/processaPlanilhaClima'
import ModalDesafioClima from '../modals/desafioClima'
import { dataTableRender } from '../components/functions'


const TabelaGestao = (props) => {


    var adesao_institucional_id = props.adesao_institucional_id
    

    var [resultadoClima, setResultadoClima] = useState()
    var [ano, setAno] = useState()
    var [hospClima_id, setHospClima_id] = useState()




    function statusArquivo(situacao) {

        
        switch (situacao) {

            case 'P':
                return 'Pendente'
                break

            case 'V':
                return 'Processado'
                break



        }

    }


    function cor(situacao) {


        switch (situacao) {

            case null:
                return '#e1f3e6'
                break

            case 'I':
                return '#efb500'
                break

            case 'C':
                return '#50c878'
                break

        }


    }

    function rotulo(situacao) {

        switch (situacao) {

            case null:
                return 'Não iniciado'
                break

            case 'I':
                return 'Incompleto'
                break

            case 'C':
                return 'Completo'
                break

        }
    }



    function corEnviado(situacao) {

        switch (situacao) {

            case 'A':
                return '#a4c9ff'
                break

            case 'P':
                return '#de2711'
                break

            case 'V':
                return '#5098ff'
                break

        }

    }


    function rotuloEnviado(situacao) {

        switch (situacao) {

            case 'A':
                return 'Em análise'
                break

            case 'P':
                return 'Com pendências'
                break

            case 'V':
                return 'Concluído'
                break


        }


    }




    async function desafioClima() {

        if (adesao_institucional_id) {



            api.get(`desafioClimaTabelaGestao/${adesao_institucional_id}`).then((result) => {

                //console.log(result.data)

                setResultadoClima(result.data.map((rs) =>

                    <tr style={{ display: rs.secaoAcoesLideranca == null && rs.secaoDadosEmissoes == null ? 'none' : 'table-row'}}>

                        <td><center>{rs.anoPerfil ? rs.anoPerfil : rs.anoDesafio}</center></td>
                        <td data-toggle="modal" data-target="#modalDesafioClima" onClick={() => { setAno(rs.anoPerfil ? rs.anoPerfil : rs.anoDesafio)}} style={{ cursor: 'pointer', backgroundColor: cor(rs.situacaoPerfilAnual)}}><center>{rotulo(rs.situacaoPerfilAnual)}</center></td>
                        <td data-toggle="modal" data-target="#modalDesafioClima" onClick={() => { setAno(rs.anoPerfil ? rs.anoPerfil : rs.anoDesafio)}} style={{ cursor: 'pointer', backgroundColor: cor(rs.secaoAcoesLideranca)}}><center>{rotulo(rs.secaoAcoesLideranca)}</center></td>
                        <td data-toggle="modal" data-target="#modalDesafioClima" onClick={() => { setAno(rs.anoPerfil ? rs.anoPerfil : rs.anoDesafio)}} style={{ cursor: 'pointer', backgroundColor: cor(rs.secaoDadosEmissoes)}}><center>{rotulo(rs.secaoDadosEmissoes)}</center></td>
                        <td data-toggle="modal" data-target="#modalDesafioClima" onClick={() => { setAno(rs.anoPerfil ? rs.anoPerfil : rs.anoDesafio)}} style={{ cursor: 'pointer', display: 'none', backgroundColor: cor(rs.secaoMeta)}}><center>{rotulo(rs.secaoMeta)}</center></td>
                        <td data-toggle="modal" data-target="#modalProcessaPlanilhaClima" onClick={() => setHospClima_id(rs.hospClima_id)} style={{ cursor: 'pointer', backgroundColor: rs.statusProcessamentoArquivo == 'V' ? '#bce3d5' : rs.statusProcessamentoArquivo == 'P' ? '#dce3bc' : rs.statusProcessamentoArquivo == 'N' ? '#e3bcbc' : '#efefef' }}><center>{statusArquivo(rs.statusProcessamentoArquivo)}</center></td>
                        <td data-toggle="modal" data-target="#modalDesafioClima" onClick={() => { setAno(rs.anoPerfil ? rs.anoPerfil : rs.anoDesafio)}} style={{ cursor: 'pointer', backgroundColor: corEnviado(rs.situacaoEnviado)}}><center>{rotuloEnviado(rs.situacaoEnviado)}</center></td>
                        <td data-toggle="modal" data-target="#modalDesafioClima" onClick={() => { setAno(rs.anoPerfil ? rs.anoPerfil : rs.anoDesafio)}} ><center>{rs.dataEnvio}</center></td>

                    </tr>
                
                ))

                dataTableRender('dataTableExampleClima')


            }).catch((err) => {

                console.log(err.response)

            })




        }

    }

    
    useEffect(() => {

        desafioClima()

    }, [])


    return (

        <div>

            <div className="table-responsive">
                <table id="dataTableExampleClima" className="table table-bordered table-striped table-hover">
                    <thead>
                        <tr>
                            <th tyle={{ backgroundColor: '#bab6b6'}}>
                                <center>
                                Ano
                                </center>

                            </th>
                            <th style={{ backgroundColor: '#bab6b6'}}> 

                                <center>
                                Form. Perfil Anual
                                </center>

                            </th>
                        
                            
                            <th style={{ backgroundColor: '#bab6b6'}}>
                                <center>
                                Dados de ações de Liderança e Resiliência
                                </center>

                            </th>

                            <th style={{ backgroundColor: '#bab6b6'}}>
                                <center>
                                Dados de Emissões de GEE
                                </center>

                            </th>


                            <th style={{ display: 'none', backgroundColor: '#bab6b6'}}>
                                <center>
                                Definição da meta
                                </center>

                            </th>

                            <th style={{ backgroundColor: '#bab6b6'}}>
                                <center>
                                Processamento planilha
                                </center>

                            </th>
                            
                            <th style={{ backgroundColor: '#bab6b6'}}>
                                <center>
                                Situação
                                </center>

                            </th>
                            <th style={{ backgroundColor: '#bab6b6'}}>
                                <center>
                                Enviado em
                                </center>

                            </th>

                            
                        </tr>
                        
                    </thead>
                    <tbody>
                        {resultadoClima}
                    </tbody>
                    
                </table>    

                <button type="button" class="btn btn-success" onClick={() => desafioClima()}>Atualizar tabela</button>&nbsp;
            
            </div>

                
                
                
                
                

            <ModalProcessaPlanilhaClima hospClima_id={hospClima_id} adesao_institucional_id={adesao_institucional_id} />
            <ModalDesafioClima hospClima_id={hospClima_id} ano={ano} adesao_institucional_id={adesao_institucional_id} fnClima={desafioClima} />


        </div>

    )

}

export default TabelaGestao